import { PagePending } from "@/components/ui/PagePending";
import { eapPurchasesForFeedbackQuery } from "@/api/sales";
import { Card } from "@/components/ui/Card";
import { EmptyState } from "@/components/ui/EmptyState";
import { PageWrapper } from "@/components/ui/PageWrapper";
import { Flex, Text } from "@givenwell/components";
import { css } from "@givenwell/stitches";
import { colors } from "@givenwell/theme";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Link, Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/eap-review")({
  pendingComponent: PagePending,
  component: Review,
});

const timeFormat = Intl.DateTimeFormat("en-NZ", {
  hour: "numeric",
  minute: "2-digit",
});

const dateFormat = Intl.DateTimeFormat("en-NZ", {
  day: "numeric",
  month: "short",
});

function Review() {
  const { supplierId } = Route.useParams();
  const { data: purchases } = useSuspenseQuery(eapPurchasesForFeedbackQuery(supplierId));

  return (
    <PageWrapper title="Session Review">
      <Flex css={{ gap: 16, flex: "1 0 0px" }}>
        <Card css={{ padding: 8, width: 320 }}>
          {purchases.purchases.map(purchase => (
            <Link
              className={linkCardCss()}
              from={Route.id}
              to="$purchaseId"
              params={{
                purchaseId: purchase.id,
              }}
              key={purchase.id}
            >
              <Text css={{ lineClamp: 1 }}>
                {timeFormat.format(new Date(purchase.booking?.start_timestamp!))} with {purchase.purchaser_name}
              </Text>
              <Text css={{ color: colors.text2, fontScale: "sm" }}>
                {purchase.listing_title} &bull; {dateFormat.format(new Date(purchase.booking?.start_timestamp!))}
              </Text>
            </Link>
          ))}
          {purchases.purchases.length === 0 && <EmptyState description="All done!" />}
        </Card>
        <Card css={{ flex: "1 0 0px", maxWidth: 500 }}>
          <Outlet />
        </Card>
      </Flex>
    </PageWrapper>
  );
}

const linkCardCss = css({
  display: "block",
  px: 8,
  py: 4,
  borderRadius: 9,
  "&[data-status=active]": {
    backgroundColor: colors.cyanAccent,
  },
});
